import { Box, Heading, HStack, Text } from "@chakra-ui/react";
import { useContext } from "react";
import { useParams } from "react-router-dom";
import { CapitalGainsChart } from "src/components/Charts/CapGainsChart";
import { IncomeChart } from "src/components/Charts/IncomeChart";
import { useTheme } from "src/hooks/useTheme";
import { FullServiceContext } from "./context";
import { YearSwitcher } from "./YearSwitcher";

export const Charts = () => {
  const { clientId } = useParams();
  const { year } = useContext(FullServiceContext);
  const theme = useTheme();

  return (
    <div
      style={{
        width: "100%",
        background: theme.medBackground,
        border: `1px solid ${theme.border}`,
        borderRadius: 10,
        padding: 15,
        paddingBottom: 0,
      }}
    >
      <HStack justifyContent="space-between" alignItems="center" mb="30px">
        <HStack spacing={3}>
          <Heading
            fontSize={24}
            fontWeight="bold"
            color={theme.header}
            style={{
              margin: 0,
              fontStretch: "expanded",
            }}
          >
            Full Service
          </Heading>
        </HStack>
        <YearSwitcher />
      </HStack>

      <HStack style={{ marginTop: 0, marginBottom: 0 }}>
        <Box style={{ flex: 1 }}>
          <Text marginBottom={25} color={theme.header} fontWeight="medium">
            Capital Gains
          </Text>
          <CapitalGainsChart
            height={100}
            clientId={clientId || ""}
            year={year}
          />
        </Box>
        <Box
          style={{
            margin: "0 15px",
            width: 2,
            borderRadius: 10,
            height: 100,
            background: theme.ternaryBackground,
          }}
        />
        <Box style={{ flex: 1 }}>
          <Text marginBottom={25} color={theme.header} fontWeight="medium">
            Income
          </Text>
          <IncomeChart height={100} clientId={clientId || ""} year={year} />
        </Box>
      </HStack>
    </div>
  );
};
